var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.html)?_c('div',{staticClass:"c-public-notice"},[_c('div',{staticClass:"m-notice-content"},[_c('img',{staticClass:"u-img",attrs:{"svg-inline":"","src":require('@/assets/img/notice.svg')}}),_c('span',{staticClass:"m-notice-text",domProps:{"innerHTML":_vm._s(_vm.html)}})])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }